// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mce-tinymce {
  box-sizing: border-box !important;
}
.mce-tinymce button:hover {
  background-color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/editor/modes/rich-text.scss"],"names":[],"mappings":"AAAA;EACC,iCAAA;AACD;AACC;EACC,yBAAA;AACF","sourcesContent":[".mce-tinymce {\n\tbox-sizing: border-box !important;\n\n\tbutton:hover {\n\t\tbackground-color: inherit;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
